window.Reverb = window.Reverb || {};
Reverb.TaxForm = Reverb.TaxForm || {};

Reverb.TaxForm.TaxID = (function () {
  const SSNSelector = '[data-ssn-inputmask]';
  const taxIDSelector = '[data-tax-id-inputmask]';

  function addSSNInputMask() {
    $(SSNSelector).inputmask('999-99-9999', { placeholder: ' ', showMaskOnHover: false, showMaskOnFocus: false });
  }

  function addTaxIDInputMask() {
    $(taxIDSelector).inputmask('99-9999999', { placeholder: ' ', showMaskOnHover: false, showMaskOnfocus: false });
  }

  function init() {
    addSSNInputMask();
    addTaxIDInputMask();
  }

  return {
    init,
  };
}());

$(Reverb.TaxForm.TaxID.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/tax_forms.js